module.exports = __webpack_public_path__ + "img/empty.6b80174a.jpg";